export enum CardVariant {
  blank = 'blank',
  turquoise = 'turquoise',
  blue = 'blue',
  myDrive = 'myDrive',
  light = 'light',
}
